export const reportRetentionsTypes = {
  SET_RETENTIONS_FILTERS: 'SET_RETENTIONS_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL'
};
